import { bindEvents } from '../../../assets/js/helpers';

import SpotifyController from '../../../assets/js/controller/spotify';

const selector = 'text-experience-detail-intro';

export default class TextExperienceDetailIntro {

	constructor(section) {
		this.el = {
			section,
			playCta: section.querySelector(`.${selector}__cta`)
		};

		this.flags = {
			hasPlaylist: false
		};

		this.states = {
			playlistId: null,
			playlistUrl: this.el.section.getAttribute('data-spotify-playlist-url')
		};


		// bind events to class scope
		this.events = bindEvents(this);

		// engage
		this.init();
	}

	static get selector() {
		return selector;
	}

	// initialize class

	init() {
		this.flags.hasPlaylist = !!this.states.playlistUrl;
		if (this.flags.hasPlaylist) {
			const playlistId = this.states.playlistUrl.substr(this.states.playlistUrl.lastIndexOf('/') + 1);
			this.states.playlistId = playlistId;
			SpotifyController.prefetch(this.states.playlistId);
		}

		this.addEventListeners();
	}

	// event listeners

	addEventListeners() {
		if (this.flags.hasPlaylist) {
			this.el.playCta.addEventListener('click', this.events._onPlayCtaClick);
		}
	}

	removeEventListeners() {
		if (this.flags.hasPlaylist) {
			this.el.playCta.removeEventListener('click', this.events._onPlayCtaClick);
		}
	}

	// listener methods

	_onPlayCtaClick(e) {
		e.preventDefault();
		if (this.states.playlistId) {
			SpotifyController.playPreviews();
		}
	}

	// destroy

	destroy() {
		this.removeEventListeners();
		this.states.playlistId = null;
		SpotifyController.destroyPlayer();
	}

}
